import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import i18n from '../i18n/i18n'

const useI18nStore = create(
  persist(
    (set) => ({
      lang: 'it',
      setLang: (lang) => {
        i18n.changeLanguage(lang)
        set({ lang })
      }
    }),
    { name: 'organizer-i18n' }
  )
)

export default useI18nStore
